// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main___p2c0","list":"TableCells_list__1OLEQ","firstItemBold":"TableCells_firstItemBold__2-wCJ","link":"TableCells_link__1nBqK"};